import { Component, OnInit } from '@angular/core';
import {PushNotificationsService } from '../_services';
import { Router, ActivatedRoute } from '@angular/router';
import { parse } from 'date-fns';
import { Configuration } from '../configuration/configurations';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
private ClientLogo:string="";
private isFromDns:string="";
private themeWrapper = document.querySelector('body');
  constructor(private _notificationService: PushNotificationsService,  private route: ActivatedRoute, private _configuration: Configuration,private _router:Router) {
    this._notificationService.requestPermission();
  }

  ngOnInit() {
    if (this.route.snapshot.queryParams['authdata']) {
         this._router.navigateByUrl('/sidebar', { skipLocationChange: true }).then(() =>
                this._router.navigate(['/dashboard'])
            );
    }
    if(localStorage.getItem("clientLogo")){
      this.ClientLogo=localStorage.getItem("clientLogo");
    }
    if(localStorage.getItem("isfromDns") && localStorage.getItem("PrimaryColor") && localStorage.getItem("SecondaryColor"))
    {
      this.isFromDns=localStorage.getItem("isfromDns")
    }
   
  }

}
